import React, { useRef, useState } from 'react';
import styles from './ContactBar.module.css';
import copy from '../../img/copy_1.webp';
import copyDone from '../../img/copy_2.webp';
import { useClickOutside } from '../../hooks/useClickOutside';
import { openInNewTab } from '../../hooks/openInNewTab';
import { SlSocialInstagram, SlPhone, SlEnvolope } from 'react-icons/sl';
import { useTheme } from '@mui/material/styles';

type ContactProps = {
  closeHandler: () => void;
  contactName: string;
  contact: string;
};

const ContactDetail = (props: ContactProps) => {
  const [isCopied, setIsCopied] = useState(true);
  const menuRef = useRef(null);

  useClickOutside(menuRef, props.closeHandler);
  const copiedHandler = () => {
    navigator.clipboard.writeText('+420774786742');
    setIsCopied(!isCopied);
  };
  return (
    <div className={`${styles.index} ${styles.centerDiv}`}>
      <div className={styles.background} ref={menuRef}>
        <h2 className={styles.marginRight}>{props.contactName}</h2>
        <br />
        <h2 className={styles.marginRight}>{props.contact}</h2>
        {isCopied ? (
          <img
            onClick={copiedHandler}
            className={styles.icon}
            src={copy}
            alt="kontakt na smartpush"
          />
        ) : (
          <img className={styles.icon} src={copyDone} alt="kontakt na smartpush" />
        )}
      </div>
    </div>
  );
};

const ContactBar = () => {
  const theme = useTheme();
  const [openHandler, setOpenHandler] = useState(false);
  const closeHandler = () => {
    setOpenHandler(!openHandler);
  };
  const iconStyle = {
    color: theme.palette.text.primary, // barva podle light/dark módu
    height: '18px',
    width: '18px',
    marginTop: '30px',
    cursor: 'pointer',
  };
  return (
    <>
      {openHandler && (
        <ContactDetail
          closeHandler={closeHandler}
          contactName="David Kopl"
          contact="+420 774 786 742"
        />
      )}

      <div className={styles.iconPosition}>
        <div onClick={() => openInNewTab('https://www.instagram.com/smart_push/')}>
          <SlSocialInstagram style={iconStyle} />
        </div>
        <div>
          <SlPhone onClick={closeHandler} style={iconStyle} />
        </div>
        <a href="mailto:kopldavid@seznam.cz">
          <SlEnvolope style={iconStyle} />
        </a>
      </div>
    </>
  );
};

export default ContactBar;
